import ReactDOM from 'react-dom';
import React from 'react';
import RegionalLogos from 'root/main/components/regionalLogos/RegionalLogos';
import SandboxRegionalLogos from './HomepageSandboxTest/SandboxRegionalLogos';

export default function () {
    const bodyEl = document.querySelector('body');
    const isSandboxTest = bodyEl?.classList.contains('acf-class-homepage-sandbox-test');

    const rootEls = document.querySelectorAll(
        '[data-react=regionalLogos]'
    ) as NodeListOf<HTMLElement>;
    rootEls.forEach(root => {
        if (isSandboxTest) {
            // Render the homepage sandbox test if the custom class is present and reduced motion is not preferred
            ReactDOM.render(
                <SandboxRegionalLogos
                    reactRegionalLogos={root.dataset.reactRegionalLogos}
                />,
                root
            );
            return;
        }
        ReactDOM.render(
            <RegionalLogos reactRegionalLogos={root.dataset.reactRegionalLogos} />,
            root
        );
    });
}
